module.exports = __webpack_public_path__ + "resources/img/img_moai_main_func_m_jp.89e8f3b9edc2fa32239ecaaf65680fed.png";